import { useEffect, useRef } from "react";

const useUpdateEffect = (effect, deps) => {
  const isMountedRef = useRef(false);
  const effectRef = useRef(effect);

  effectRef.current = effect;

  useEffect(() => {
    if (isMountedRef.current) {
      return effectRef.current();
    }

    isMountedRef.current = true;
    return undefined;
  }, deps);
};

export default useUpdateEffect;
